import React, { useState } from 'react'
import axios from "axios";
import { styled } from '@mui/material/styles';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import Toolbar from '@mui/material/Toolbar';
import MuiDrawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import MuiAppBar from '@mui/material/AppBar';
import Typography from '@mui/material/Typography';
import MenuIcon from '@mui/icons-material/Menu';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DashboardIcon from '@mui/icons-material/Dashboard';
import EventNoteIcon from '@mui/icons-material/EventNote';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import { Menu } from '@mui/material';
import { MenuItem, useMediaQuery, useTheme } from '@mui/material';
import Swal from 'sweetalert2'
import { useHistory } from 'react-router-dom';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import SettingsIcon from '@mui/icons-material/Settings';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import RateReviewIcon from '@mui/icons-material/RateReview';
//import Badge from '@mui/material/Badge';

import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import AppSettingsAltIcon from '@mui/icons-material/AppSettingsAlt';
import ArticleIcon from '@mui/icons-material/Article';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import SwipeLeftIcon from '@mui/icons-material/SwipeLeft';
import FeedIcon from '@mui/icons-material/Feed';
import CommentIcon from '@mui/icons-material/Comment';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import InfoIcon from '@mui/icons-material/Info';
import LocalPostOfficeIcon from '@mui/icons-material/LocalPostOffice';
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import AddCardIcon from '@mui/icons-material/AddCard';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import BadgeIcon from '@mui/icons-material/Badge';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import { useLocation } from 'react-router-dom';
import FolderSharedIcon from '@mui/icons-material/FolderShared';

import MailIcon from "@mui/icons-material/Mail";

import { Button } from '@mui/material';


import swal from "sweetalert";
import CancelIcon from '@mui/icons-material/Cancel';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';

import Input from '@mui/material/Input';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';

import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';
import CheckIcon from '@mui/icons-material/Check';
import Badge from '@mui/material/Badge';
import moment from 'moment';
import AbstractNav from './AbstractNav';
import ExhibitionNav from './ExhibitionNav';
import WorkshopNav from './WorkshopNav';
import PmsNav from './PmsNav';
const drawerWidth = 240;

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        '& .MuiDrawer-paper': {
            position: 'relative',
            whiteSpace: 'nowrap',
            width: drawerWidth,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
            boxSizing: 'border-box',
            ...(!open && {
                overflowX: 'hidden',
                transition: theme.transitions.create('width', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
                width: theme.spacing(7),
                [theme.breakpoints.up('sm')]: {
                    width: theme.spacing(9),
                },
            }),
        },
    }),
);



const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));



function SideBar() {
    const location = useLocation();
    const currentPath = location.pathname;
    const [module, setModules] = useState([]);
    const [loadning, setLoadning] = useState(false);
    const [opensnoti, setOpensNoti] = useState(false);
    const [permissions, setrPermissions] = useState([]);
    const [anchorElmNoti, setAnchorElmNoti] = useState(null);
    const [notificationRead, setNotificationRead] = React.useState([]);
    const [abstractNotification, setAbstractNotification] = React.useState([]);
    const [abstractNotificationcount, setAbstractNotificationCount] = React.useState([]);
    const eventid = localStorage.getItem('eventid')
    const AuthUserName = localStorage.getItem('auth_name');
    const organiserId = localStorage.getItem('user_id');
    const selfprint = localStorage.getItem('auth_name');
    const eventName = localStorage.getItem('eventname');
    const [reloadCounter, setReloadCounter] = useState(0);

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))

    const [open, setOpen] = React.useState(true);
    const toggleDrawer = () => {
        setOpen(!open);
    };

    React.useEffect(() => {
        if (isSmallScreen) {
            setOpen(false); // Auto-close AppBar on small screens
        }
    }, [isSmallScreen]);

    const [anchorElm, setAnchorElm] = useState(null);
    const [opens, setOpens] = useState(false);
    const handleClose = () => {
        setAnchorElm(null);
        setOpens(false);

    }
    const handleClick = (e) => {

        setAnchorElm(e.currentTarget);
        setOpens(true);

    }
    try {
        React.useEffect(() => {
            axios.get(`api/getpermissionByRole`).then(res => {
                if (res.status === 200) {
                    const datad = res.data.data.permissions;
                    setrPermissions(datad)
                }
            })

        }, []);

    } catch (error) {
        console.error('Error fetching data:', error);
    }



    const fetchData = async () => {
        try {
            const response = await axios.get(`api/modules-access/${eventid},${organiserId}`);
            setModules(response.data.mod);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    React.useEffect(() => {
        axios.get(`api/notificationTotalcount`).then(res => {

            if (res.status === 200) {
                const setAbstractReviewerData = res.data;

                setAbstractNotificationCount(setAbstractReviewerData)

            } else {
                swal('Error', "Check API Something Wrong", 'error');

            }
        })

    }, []);



    React.useEffect(() => {
        axios.get(`api/readnotificationCount`).then(res => {

            if (res.status === 200) {
                const setAbstractReviewerData = res.data;

                setNotificationRead(setAbstractReviewerData)

            } else {
                swal('Error', "Check API Something Wrong", 'error');

            }
        })

    }, []);


    const readNotification = (e) => {
        e.preventDefault();
        axios.get(`api/markAsRead`).then(res => {

            if (res.status === 200) {
                const setNotification = res.data;

                swal('Success', res.data.message, 'success');
                window.location.reload(false);

            } else {
                swal('Error', "Check API Something Wrong", 'error');

            }
        })


    }

    const handleClickNoti = (e) => {

        setAnchorElmNoti(e.currentTarget);
        setOpensNoti(true);
        loadList();

    }

    const loadList = async () => {
        const restult = await axios.get(`api/notification`);

        setAbstractNotification(restult.data.notifications);

    }

    const handleCloseNoti = () => {
        setAnchorElmNoti(null);
        setOpensNoti(false);

    }

    const history = useHistory();

    const logoutSubmit = (e) => {
        e.preventDefault();

        axios.post(`api/logout`).then(res => {
            if (res.data.status === 200) {
                localStorage.removeItem('auth_token');
                localStorage.removeItem('auth_name');
                //localStorage.removeItem('eventid');
                localStorage.removeItem('role');
                localStorage.removeItem('user_id');
                localStorage.removeItem('eventname');
                localStorage.removeItem('abstractId');
                //swal('Success',res.data.message,'success');
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: res.data.message,
                    showConfirmButton: false,
                    timer: 1500
                })


                if (eventid !== "") {
                    console.log("Current Path:", currentPath); // Debugging statement

                    if (currentPath && currentPath.startsWith('/admin/workshop/')) {
                        history.push('/workshop/particpant-verification');
                        //history.push('/');
                    } else if (
                        currentPath &&
                        (
                            currentPath.startsWith('/admin/abstract/') ||
                            currentPath.startsWith('/admin/requirements/') ||
                            currentPath.startsWith('/admin/reviewer/') ||
                            currentPath.startsWith('/admin/moderator/') ||
                            currentPath.startsWith('/admin/author/') ||
                            currentPath.startsWith('/admin/profile/') ||
                            currentPath.startsWith('/admin/questions/')
                        )
                    ) {
                        history.push('/author/login');
                    } else {
                        history.push('/');
                    }
                } else {
                    history.push('/');
                }
            }

        });

    }


    const [openAbstractMenu, setOpenAbstractMenu] = React.useState(false);

    const handleClickAbstractMenu = () => {
        setOpenAbstractMenu(!openAbstractMenu);
    }

    const [openAbstractSubMenu, setOpenAbstractSubMenu] = React.useState(false);

    const handleClickAbstractSubMenu = () => {
        setOpenAbstractSubMenu(!openAbstractSubMenu);
    }

    const [openAbstractArticle, setOpenAbstractArticle] = React.useState(false);
    const handleClickAbstractArticle = () => {
        setOpenAbstractArticle(!openAbstractArticle);
    }
    const role = localStorage.getItem('role');
    const [openEdit, setOpenForEdit] = useState(false);

    //EMS
    const [openExhibitionMenu, setOpenExhibitionMenu] = React.useState(false);
    const handleClickExhibitionMenu = () => {
        setOpenExhibitionMenu(!openExhibitionMenu);
    }
    const [openExhibitionBooth, setOpenExhibitionBooth] = React.useState(false);
    const handleClickExhibitionBooth = () => {
        setOpenExhibitionBooth(!openExhibitionBooth);
    }
    const [openExhibitionExhibitor, setOpenExhibitionExhibitor] = React.useState(false);
    const handleClickExhibitionExhibitor = () => {
        setOpenExhibitionExhibitor(!openExhibitionExhibitor);
    }
    const [openExhibitionItemService, setOpenExhibitionItemService] = React.useState(false);
    const handleClickExhibitionItemService = () => {
        setOpenExhibitionItemService(!openExhibitionItemService);
    }
    const [openExhibitionSetting, setOpenExhibitionSetting] = React.useState(false);
    const handleClickExhibitionSetting = () => {
        setOpenExhibitionSetting(!openExhibitionSetting);
    }
    const [openExhibitionGuestFrom, setOpenExhibitionGuestFrom] = React.useState(false);
    const handleClickExhibitionGuestFrom = () => {
        setOpenExhibitionGuestFrom(!openExhibitionGuestFrom);
    }

    //WorkShop

    const [openWorkShopMenu, setOpenWorkShopnMenu] = React.useState(false);
    const handleClickWorkShopMenu = () => {
        setOpenWorkShopnMenu(!openWorkShopMenu);
    }

    const [openWorkShopEventManagemant, setOpenWorkShopEventManagemant] = React.useState(false);
    const handleClickopenWorkShopEventManagemant = () => {
        setOpenWorkShopEventManagemant(!openWorkShopEventManagemant);
    }

    const [openClickWorkShopUser, setOpenClickWorkShopUser] = React.useState(false);
    const handleClickWorkShopUser = () => {
        setOpenClickWorkShopUser(!openClickWorkShopUser);
    }

    const [openWorkShopParticpant, setOpenWorkShopParticpant] = React.useState(false);
    const handleClickWorkShopParticpant = () => {
        setOpenWorkShopParticpant(!openWorkShopParticpant);
    }
    const [openWorkShopSetting, setOpenWorkShopSettingg] = React.useState(false);
    const handleClickWorkShopSetting = () => {
        setOpenWorkShopSettingg(!openWorkShopSetting);
    }
    //Conference 
    const [openConferenceMenu, setOpenConferenceMenu] = React.useState(false);
    const handleClickConferenceMenu = () => {
        setOpenConferenceMenu(!openConferenceMenu);
    }

    const [openConferenceEventManagemant, setOpenConferenceEventManagemant] = React.useState(false);
    const handleClickopenConferenceEventManagemant = () => {
        setOpenConferenceEventManagemant(!openConferenceEventManagemant);
    }

    const [openConferenceParticpant, setOpenConferenceParticpant] = React.useState(false);
    const handleClickConferenceParticpant = () => {
        setOpenConferenceParticpant(!openConferenceParticpant);
    }


    const [openClickConferenceUser, setOpenClickConferenceUser] = React.useState(false);
    const handleClickConferenceUser = () => {
        setOpenClickConferenceUser(!openClickConferenceUser);
    }


    const [openConferenceSetting, setOpenConferenceSettingg] = React.useState(false);
    const handleClickConferenceShopSetting = () => {
        setOpenConferenceSettingg(!openConferenceSetting);
    }


    React.useEffect(() => {
        const organiserId = localStorage.getItem('user_id')
        axios.get(`api/modules-access/${eventid},${organiserId}`).then(res => {
            if (res.status === 200) {
                setModules(res.data.mod);
            }

        });
        if (reloadCounter < 5) {
            const timeoutId = setTimeout(() => {
                setReloadCounter(prevCounter => prevCounter + 1);
            }, 3000);
            return () => clearTimeout(timeoutId);
        }
    }, [reloadCounter]);


    const [abstractHomeSetup, setAbstractHomeSetup] = useState({
        color_code: "",
        color_code_two: "",
        color_code_three: "",
        call_emergency: "",
        send_email: "",
        event_place: "",
        facebook_link: "",
        Instagram_link: "",
        linkedin_link: "",
        twitter_link: "",
        abstractFooterImage: "",
        abstractBannerImage: "",
        abstractSponserLogos: "",
        error_list: [],
    });
    React.useEffect(() => {
        axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
            if (res.status === 200) {
                const getHomePageData = res.data.HomePageSetup;
                setAbstractHomeSetup(getHomePageData);
            }
        })

    }, [eventid]);

    const [userStatus, setUserStatus] = useState('participant');
    React.useEffect(() => {
        axios.get(`api/speaker/profile`).then(res => {
            if (res.data?.userID?.participant_join_id === 1 && res.data?.userID?.event_id === eventid) {
                setUserStatus('speaker');
            } else {
                setUserStatus('participant');

            }
        }).catch(error => {
            console.error('Failed to fetch speaker info:', error);
            setUserStatus('participant'); // Fallback if the API call fails

        })

    }, [eventid]);


    const getBackgroundColor = () => {
        // Define your logic to determine the background color based on the ID

        if (eventid) {
            return `${abstractHomeSetup.color_code}`;
        }
    };

    const paperStyle = {
        backgroundColor: getBackgroundColor(),
        // Adjust as needed
    };

    const staticChange = eventid == 68;
    return (


        <Box sx={{ display: 'flex' }}>
            <CssBaseline />


            <AppBar position="absolute" open={open}>
                <Toolbar style={paperStyle} sx={{ flexWrap: 'wrap' }}>
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                        onClick={toggleDrawer}
                        sx={{ marginRight: '16px', ...(open && { display: 'none' }) }}
                    >
                        <MenuIcon />
                    </IconButton>

                    <Typography
                        component="h1"
                        variant="h6"
                        color="inherit"
                        noWrap
                        sx={{ flexGrow: 1, fontSize: isSmallScreen ? '1rem' : '1.25rem' }}
                    >
                        {currentPath === '/admin/events' ? 'Dashboard' : eventName}
                    </Typography>

                    {/* User name - hidden on very small screens */}
                    {!isSmallScreen && (
                        <IconButton sx={{ color: 'white', marginRight: '2%' }}>
                            {AuthUserName}
                        </IconButton>
                    )}

                    {/* Notifications */}
                    <Badge badgeContent={abstractNotificationcount || 0}>
                        <NotificationsActiveIcon
                            sx={{ color: 'white', cursor: 'pointer' }}
                            onClick={handleClickNoti}
                        />
                    </Badge>

                    {/* Notifications Menu */}
                    <Menu anchorEl={anchorElmNoti} open={opensnoti} onClose={handleCloseNoti}>
                        {abstractNotification && abstractNotification?.length > 0 ? (
                            abstractNotification?.map((item) => (
                                <MenuItem key={item.id}>
                                    <Typography align="center">
                                        {item.data} {item.title} &nbsp;&nbsp;&nbsp;&nbsp;
                                        {moment.utc(item.created_at).local().startOf('seconds').fromNow()}
                                    </Typography>
                                </MenuItem>
                            ))
                        ) : (
                            <Typography align="center" sx={{ p: 2, color: 'text.secondary' }}>
                                No notifications
                            </Typography>
                        )}

                        {abstractNotification && abstractNotification?.length > 0 && (
                            <Typography
                                sx={{ mt: 2, cursor: 'pointer' }}
                                align="center"
                                onClick={readNotification}
                            >
                                Mark As Read
                                <CheckIcon sx={{ color: '#1976d2' }} />
                            </Typography>
                        )}

                    </Menu>

                    {/* Settings */}
                    <IconButton
                        onClick={handleClick}
                        sx={{ color: 'white', marginRight: '1%', marginLeft: '3%' }}
                    >
                        <SettingsIcon />
                    </IconButton>

                    {/* Settings Menu */}
                    <Menu anchorEl={anchorElm} open={opens} onClose={handleClose}>
                        <MenuItem onClick={() => history.push('/admin/profile/profile')}>
                            Profile &nbsp;&nbsp;
                            <ManageAccountsIcon sx={{ color: '#1976d2' }} />
                        </MenuItem>
                        <MenuItem onClick={handleClose}>
                            Setting &nbsp;&nbsp;
                            <AdminPanelSettingsIcon sx={{ color: '#1976d2' }} />
                        </MenuItem>
                        <MenuItem onClick={logoutSubmit}>
                            LogOut &nbsp;&nbsp;
                            <PowerSettingsNewIcon sx={{ color: '#1976d2' }} />
                        </MenuItem>
                    </Menu>
                </Toolbar>
            </AppBar>

            <Drawer variant="permanent" open={open}>
                <Toolbar
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        px: [1],
                        mt: 3,


                    }}
                >
                    <IconButton onClick={toggleDrawer}>
                        <ChevronLeftIcon />
                    </IconButton>
                </Toolbar>
                <Divider />
                <List component="nav">

                    {/* {role === 'Author' ? '' : */}
                    {
                        role === 'participant' ? (
                            <>
                                <ListItemButton onClick={() => history.push('/admin/conference/participant-dashboard')}>
                                    <ListItemIcon sx={{ color: '#1976d2' }}>
                                        <DashboardIcon onClick={() => history.push('/admin/conference/participant-dashboard')} />
                                    </ListItemIcon>
                                    <ListItemText primary="Dashboard"
                                        onClick={() => history.push('/admin/conference/participant-dashboard')} />

                                </ListItemButton>
                                {currentPath !== '/admin/conference/participant-dashboard' && (
                                    <>
                                        {userStatus === 'speaker' && eventid && (
                                            <>
                                                <Divider sx={{ my: 1 }} />
                                                <ListItemButton onClick={() => history.push(`/admin/conference/speaker-dashbord/${eventid}`)}>
                                                    <ListItemIcon sx={{ color: '#1976d2' }}>
                                                        <GroupAddIcon />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Profile" />
                                                </ListItemButton>
                                            </>
                                        )}

                                        <Divider sx={{ my: 1 }} />
                                        {!staticChange && eventid && (
                                            <ListItemButton onClick={() => history.push(`/admin/conference/single-event-dashbord/${eventid}`)}>
                                                <ListItemIcon sx={{ color: '#1976d2' }}>
                                                    <GroupAddIcon />
                                                </ListItemIcon>
                                                <ListItemText primary="Chat" />
                                            </ListItemButton>
                                        )}
                                    </>

                                )}





                            </>

                        ) : (
                            <ListItemButton onClick={() => history.push('/admin/events')}>
                                <ListItemIcon
                                    sx={{
                                        color: '#1976d2',
                                    }}
                                >
                                    <EventNoteIcon onClick={() => history.push('/admin/events')} />
                                </ListItemIcon>
                                <ListItemText primary="All Events"
                                    onClick={() => history.push('/admin/events')} />
                            </ListItemButton>
                        )
                    }

                    <Divider sx={{ my: 1 }} />

                          {currentPath !== '/admin/events' && permissions['p_user-list'] === true && (
                        <>
                            <Divider sx={{ my: 1 }} />
                            <ListItemButton>
                                <ListItemIcon sx={{ color: '#1976d2' }}>
                                    <GroupAddIcon onClick={() => history.push('/admin/whatsapp-messenger')} />
                                </ListItemIcon>
                                <ListItemText primary="Whatsapp" onClick={() => history.push('/admin/whatsapp-messenger')} />
                            </ListItemButton>

                        </>
                    )}


                    {currentPath !== '/admin/events' && permissions['p_user-list'] === true && (
                        <>
                            <Divider sx={{ my: 1 }} />
                            <ListItemButton>
                                <ListItemIcon sx={{ color: '#1976d2' }}>
                                    <GroupAddIcon onClick={() => history.push('/admin/user')} />
                                </ListItemIcon>
                                <ListItemText primary="User" onClick={() => history.push('/admin/user')} />
                            </ListItemButton>

                        </>
                    )}

                    {currentPath !== '/admin/events' && permissions['p_role-list'] === true && (
                        <ListItemButton>
                            <ListItemIcon sx={{ color: '#1976d2' }}>
                                <PlaylistAddCheckIcon onClick={() => history.push('/admin/role')} />
                            </ListItemIcon>
                            <ListItemText primary="Role" onClick={() => history.push('/admin/role')} />
                        </ListItemButton>
                    )}

                    {currentPath !== '/admin/events' && permissions['p_custom-field-list'] === true && (
                        <ListItemButton>
                            <ListItemIcon sx={{ color: '#1976d2' }}>
                                <PlaylistAddCheckIcon onClick={() => history.push('/admin/from/custom-list')} />
                            </ListItemIcon>
                            <ListItemText primary="Custom Field" onClick={() => history.push('/admin/from/custom-list')} />
                        </ListItemButton>
                    )}

                    {currentPath !== '/admin/events' && permissions['p_event-smtp-setting'] === true && (
                        <ListItemButton>
                            <ListItemIcon sx={{ color: '#1976d2' }}>
                                <BadgeIcon onClick={() => history.push('/admin/email/setting')} />
                            </ListItemIcon>
                            <ListItemText primary="Email Setting" onClick={() => history.push('/admin/email/setting')} />
                        </ListItemButton>
                    )}

                    {currentPath !== '/admin/events' && permissions['p_event-payment-setting'] === true && (
                        <ListItemButton>
                            <ListItemIcon sx={{ color: '#1976d2' }}>
                                <BadgeIcon onClick={() => history.push('/admin/payment/setting')} />
                            </ListItemIcon>
                            <ListItemText primary="Payment Setting" onClick={() => history.push('/admin/payment/setting')} />
                        </ListItemButton>
                    )}

                    {currentPath !== '/admin/events' && permissions['p_event-smtp-setting'] === true && (
                        <ListItemButton>
                            <ListItemIcon sx={{ color: '#1976d2' }}>
                                <ContactPageIcon />
                            </ListItemIcon>
                            <ListItemText primary="Home Page Setup" onClick={() => history.push('/admin/abstract/index-home-page')} />
                        </ListItemButton>
                    )}

                    {currentPath !== '/admin/events' && permissions['p_event-smtp-setting'] === true && (
                        <ListItemButton>
                            <ListItemIcon sx={{ color: '#1976d2' }}>
                                <ContactPageIcon />
                            </ListItemIcon>
                            <ListItemText primary="Options" onClick={() => history.push('/admin/options/index-assign')} />
                        </ListItemButton>
                    )}
                    {currentPath !== '/admin/events' && permissions['p_conference-affiliation-dashbord'] === true && (
                        <ListItemButton>
                            <ListItemIcon sx={{ color: '#1976d2' }}>
                                <ContactPageIcon />
                            </ListItemIcon>
                            <ListItemText primary="Affiliation" onClick={() => history.push('/admin/affiliation/dashbord')} />
                        </ListItemButton>
                    )}
                    {module.map((item, index) => {
                        if (item.module === 'AMS') {
                            return (
                                <AbstractNav
                                    key={item.id}
                                    permissions={permissions}
                                    currentPath={currentPath}
                                    openAbstractMenu={openAbstractMenu}
                                    handleClickAbstractMenu={handleClickAbstractMenu}
                                    openAbstractArticle={openAbstractArticle}
                                    handleClickAbstractArticle={handleClickAbstractArticle}
                                    openAbstractSubMenu={openAbstractSubMenu}
                                    handleClickAbstractSubMenu={handleClickAbstractSubMenu}
                                />
                            );
                        }
                        return null;
                    })}
                    {/* End Abstract MS */}

                    {/* Start Exhibition  MS   */}
                    {module.map((item, index) => {
                        if (item.module === 'EMS') {
                            return (
                                <ExhibitionNav
                                    key={item.id}
                                    permissions={permissions}
                                    currentPath={currentPath}
                                    openExhibitionMenu={openExhibitionMenu}
                                    handleClickExhibitionMenu={handleClickExhibitionMenu}
                                    openExhibitionBooth={openExhibitionBooth}
                                    handleClickExhibitionBooth={handleClickExhibitionBooth}
                                    openExhibitionExhibitor={openExhibitionExhibitor}
                                    handleClickExhibitionExhibitor={handleClickExhibitionExhibitor}
                                    openExhibitionGuestFrom={openExhibitionGuestFrom}
                                    handleClickExhibitionGuestFrom={handleClickExhibitionGuestFrom}
                                    openExhibitionSetting={openExhibitionSetting}
                                    handleClickExhibitionSetting={handleClickExhibitionSetting}
                                />
                            );
                        }
                    })}




                    {/* Start Workshop  MS   */}

                    {module.map((item, index) => {
                        if (item.module === 'WMS') {
                            return (
                                <WorkshopNav
                                    key={item.id}
                                    permissions={permissions}
                                    currentPath={currentPath}
                                    openWorkShopMenu={openWorkShopMenu}
                                    handleClickWorkShopMenu={handleClickWorkShopMenu}
                                    openWorkShopEventManagemant={openWorkShopEventManagemant}
                                    handleClickopenWorkShopEventManagemant={handleClickopenWorkShopEventManagemant}
                                    openWorkShopParticpant={openWorkShopParticpant}
                                    handleClickWorkShopParticpant={handleClickWorkShopParticpant}
                                    openWorkShopSetting={openWorkShopSetting}
                                    handleClickWorkShopSetting={handleClickWorkShopSetting}
                                    openClickWorkShopUser={openClickWorkShopUser}
                                    handleClickWorkShopUser={handleClickWorkShopUser}
                                />
                            );
                        }
                    })}


                    {/* Start Participant  MS   */}

                    {module.map((item, index) => {
                        if (item.module === 'PMS') {
                            return (
                                <PmsNav
                                    key={item.id}
                                    permissions={permissions}
                                    currentPath={currentPath}
                                    openConferenceMenu={openConferenceMenu}
                                    handleClickConferenceMenu={handleClickConferenceMenu}
                                    openConferenceEventManagemant={openConferenceEventManagemant}
                                    handleClickopenConferenceEventManagemant={handleClickopenConferenceEventManagemant}
                                    openConferenceParticpant={openConferenceParticpant}
                                    handleClickConferenceParticpant={handleClickConferenceParticpant}
                                    openConferenceSetting={openConferenceSetting}
                                    handleClickConferenceShopSetting={handleClickConferenceShopSetting}
                                    openClickConferenceUser={openClickConferenceUser}
                                    handleClickConferenceUser={handleClickConferenceUser}
                                />
                            );
                        }
                    })}

                    <Divider sx={{ my: 1 }} />




                </List>
            </Drawer>
        </Box>



    )
}

export default SideBar
